import { render, staticRenderFns } from "./ConfiguracaoSalvar.vue?vue&type=template&id=26624c50"
import script from "./ConfiguracaoSalvar.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoSalvar.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoSalvar.vue?vue&type=style&index=0&id=26624c50&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports